(ns kyber.components.base.card
  (:require [kyber.styles.core :refer [styles->classes gs]]))

(def base-card
  {:border (str "1px solid"
                (gs [:colors :gray-scale-200]))
   :border-radius (gs [:radius :r7])
   :padding (gs [:spacing :p28])
   :position :relative
   :margin-bottom (gs [:spacing :p20])
   :background-color (gs [:colors :true-white])})

(def styles
  {:base base-card

   :authentication-card (merge base-card
                               {:border :none
                                :box-shadow (gs [:shadows :shadow-12])
                                :width "600px"
                                :margin [[(gs [:spacing :p40])
                                          "auto"]]
                                (gs [:queries :mobile-landscape])
                                {:box-shadow :none
                                 :margin (gs [:spacing :p0])
                                 :width "100%"
                                 :border-bottom :none
                                 :border-radius (gs [:radius :r0])}})})

(def classes
  (styles->classes styles))

(defn card
  {:doc "Card border around inner contents"}
  ([content] [card {} content])
  ([options content]
   [:div
    (update options :class #(into [(:base classes)] %))
    content]))

(defn authentication-card
  {:doc "Card used for authentication views"}
  [& content]
  (let [body (into [:<>] content)]
    [:div {:class (:authentication-card classes)} body]))
